export default {
  items: [
    {
      name: 'Pesagem',
      url: '/pesagem',
      icon: 'icon-speedometer'
    }, 
    {
      name: 'Ultimas Pesagens',
      url: '/pesagens',
      icon: 'icon-speedometer'
    }, 
    {
      name: 'Fechamentos',
      url: '/fechamentos',
      icon: 'icon-speedometer'
    }, 
  ]
}